var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestrictedAccessSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,25h-1.2796021L19.5810547,3.5810547C19.0664062,2.0371094,17.6269531,1,16,1s-3.0664062,1.0371094-3.5810547,2.5810547 L5.2796021,25H4c-1.6542969,0-3,1.3457031-3,3s1.3457031,3,3,3h24c1.6542969,0,3-1.3457031,3-3S29.6542969,25,28,25z M28,29H4 c-0.5517578,0-1-0.4482422-1-1s0.4482422-1,1-1h24c0.5517578,0,1,0.4482422,1,1S28.5517578,29,28,29z M16,3 c0.765625,0,1.4423828,0.4882812,1.6845703,1.2138672L20.2798462,12h-8.5596924l2.5952759-7.7861328 C14.5576172,3.4882812,15.234375,3,16,3z M20.9464722,14l1.333252,4H9.7202759l1.333252-4H20.9464722z M9.0535889,20h13.8928223 l1.6665649,5H7.3870239L9.0535889,20z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedAccessSmall);
export default __webpack_public_path__ + "static/media/restricted-access--small.7d5e4e07fdc0c832c86327dfa537b85d.svg";
export { ForwardRef as ReactComponent };